import React from 'react'
import { Label } from 'semantic-ui-react'
import styled from 'styled-components';

const CountContainer = styled.div`
  float: right;
  
  @media (max-width: 768px) {
    float: none;
    position: absolute;
    top: -2px;
    right: 0;
  }
`;


export default class Count extends React.PureComponent {
  render() {
    const { count } = this.props;

    if(count || count === 0) {
      return (
        <CountContainer>
          <Label circular color={ count > 0 ?  "green" : undefined }>
            { count }
          </Label>
        </CountContainer>
      );
    }

    return null;
  }
}